import { getRouteAttributeText } from '@/root/modules/shared/SelectDateTimePage'

/** The route attribute that opens the block, e.g. `CARDECK_SVI-ROH-SVI-COEF_HEADER_ET`. */
const headerKey = (route: string): string => `CARDECK_${route}-COEF_HEADER`

/**
 * Turns the condition codes a sailing applied into the lines to show, newest knowledge first: the code
 * plus the interface locale IS the attribute key, so nothing here knows what a condition means — no
 * weekdays, no thresholds, no route tables. That stays tariff configuration.
 *
 * No codes means the ordinary price applies and there is nothing to say. When at least one code can
 * be named, only configured texts are shown. When none can be named, the fallback stands alone; the
 * header is dropped because it would promise a list and deliver none.
 */
export const getCoefficientNotice = ({
  locale,
  fallback,
  coefficients,
  routeAttributes,
  route,
}: {
  locale: string
  fallback: string
  coefficients?: readonly string[]
  routeAttributes?: Record<string, boolean | string>
  route?: string
}): string[] => {
  const codes = coefficients ?? []
  if (codes.length === 0) return []

  const conditions = codes
    .map((code) => getRouteAttributeText(routeAttributes, locale, code, ''))
    .filter((text) => text !== '')
  if (conditions.length === 0) return [fallback]

  const header =
    route === undefined || route === '' ? '' : getRouteAttributeText(routeAttributes, locale, headerKey(route), '')

  return header === '' ? conditions : [header, ...conditions]
}
